import React from 'react';

// Components
import { Section } from 'react-bulma-components';

const Email = () => {
    return (
        <Section>
            <h1>Email</h1>
            <hr />
            In development
        </Section>
    );
}

export default Email;
